const SvgIcon = ({defaultPath = '/img/', iconName, className}) => {
    return (
        <img src={defaultPath + iconName + '.svg'} alt={iconName} className={`${className}`} />
    );
};

export default SvgIcon;